
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#92b8b8","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6.12","cy":"1.216","r":"1.125"}}),_c('circle',{attrs:{"cx":"6.12","cy":"6.023","r":"1.125"}}),_c('circle',{attrs:{"cx":"6.12","cy":"10.931","r":"1.125"}}),_c('circle',{attrs:{"cx":"6.12","cy":"15.784","r":"1.125"}}),_c('circle',{attrs:{"cx":"10.88","cy":"1.216","r":"1.125"}}),_c('circle',{attrs:{"cx":"10.88","cy":"6.023","r":"1.125"}}),_c('circle',{attrs:{"cx":"10.88","cy":"10.931","r":"1.125"}}),_c('circle',{attrs:{"cx":"10.88","cy":"15.784","r":"1.125"}})])
          )
        }
      }
    